import { mdiMenuDown } from '@mdi/js';
import Icon from '@mdi/react';
import { PopOverVM } from 'cd-eft/components/common/PopOver/PopOverVM';
import { observer } from 'mobx-react';
import React, { useRef } from 'react';
import './DropdownPopover.scss'

interface IPopOverComponentProps {
  key?: number;
  id?: number;
  children: any;
  buttonText?: string;
  buttonAriaLabel?: string;
  childrenAriaLabel?: string;
}

const DropdownPopoverContainer = (props: IPopOverComponentProps) => {
  const vmRef = useRef<PopOverVM>();
  if (!vmRef.current) {
    vmRef.current = new PopOverVM();
  }
  const vm = vmRef.current;

  const { children, buttonText, buttonAriaLabel, childrenAriaLabel } = props;

  return (
    <div className="dropdown-popover-container">
      <div className="dropdown">
        <button
          className="usa-button usa-button--unstyled"
          aria-label={buttonAriaLabel ? buttonAriaLabel : ''}
          data-toggle="dropdown"
          aria-expanded={vm.popOverOpen}
          onClick={vm.toggle}
        >
          {buttonText ? buttonText : null}
          <Icon className="icon" path={mdiMenuDown} size={1} />
        </button>
        <div
          className="dropdown-menu show"
          aria-label={childrenAriaLabel ? childrenAriaLabel : ''}
          hidden={!vm.popOverOpen}
          tabIndex={0}
        >
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export const DropdownPopover = observer(DropdownPopoverContainer);
